<div class="not-found-wrapper">
  <div class="wrapper-inner">
    <img src="../assets/images/empty-state-icon.svg" />
    <h3 class="not-found-heading">404 Page not found!</h3>
    <p class="not-found-des">Sorry, we couldn’t find the page your are looking for</p>
  </div>
</div>
